'use strict';

var UserManagementCommonCustomRenderersFactory = function UserManagementCommonCustomRenderersFactory($interpolate) {
  var editInterpolate = $interpolate(require('../templates/user-management-edit-button-renderer.html'));
  function editbuttonRenderer(columnContext, row, columnField, value, defaultValue) {
    var data = {
      uid: row,
      fieldId: columnField,
      label: value
    };
    return defaultValue.replace('>' + value + '<', '>' + editInterpolate(data) + '<');
  }
  function viewDetailsRenderer(columnContext, row, columnField, value, defaultValue) {
    if (value) {
      return defaultValue.replace('>' + value + '<', '><a>View Details</a><');
    }
    return defaultValue;
  }
  return {
    editButton: editbuttonRenderer,
    viewDetails: viewDetailsRenderer
  };
};
UserManagementCommonCustomRenderersFactory.$inject = ['$interpolate'];
module.exports = UserManagementCommonCustomRenderersFactory;